import { render, staticRenderFns } from "./src/pages/layout/footer.html?vue&type=template&id=6efffae3&scoped=true&"
import script from "./src/pages/layout/footer.js?vue&type=script&lang=js&"
export * from "./src/pages/layout/footer.js?vue&type=script&lang=js&"
import style0 from "./src/pages/layout/footer.scss?vue&type=style&index=0&id=6efffae3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efffae3",
  null
  
)

export default component.exports